import React from "react";

const IconAddAnnonce = ({ size, ...props }) => {
    return(   
    size === 'big' ?
    <svg width={76} height={76} fill="none" {...props}>
    <path
        d="M38.583 2.255V73.14M2.378 35.866h70.885"
        stroke="#73C316"
        strokeWidth={4}
        strokeLinecap="round"
    />
    </svg> :
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM12.16 4C12.7123 4 13.16 4.44772 13.16 5V10.84H19C19.5523 10.84 20 11.2877 20 11.84C20 12.3923 19.5523 12.84 19 12.84H13.16L13.16 19.28C13.16 19.8323 12.7123 20.28 12.16 20.28C11.6077 20.28 11.16 19.8323 11.16 19.28L11.16 12.84L4.72 12.84C4.16772 12.84 3.72 12.3923 3.72 11.84C3.72 11.2877 4.16772 10.84 4.72 10.84L11.16 10.84V5C11.16 4.44772 11.6077 4 12.16 4Z" fill="#94D63D"/>
    </svg>

    )
}

export default IconAddAnnonce;